import ajax from './ajax';

export async function resubscribeSubscription(data) {
     return ajax('/resources/resubscribe-subscription/', { method: 'POST', data })
}
